import { render } from "./CheckoutWhiteVideo.vue?vue&type=template&id=671ee675"
import script from "./CheckoutWhiteVideo.vue?vue&type=script&lang=js"
export * from "./CheckoutWhiteVideo.vue?vue&type=script&lang=js"

import "./CheckoutWhiteVideo.vue?vue&type=style&index=0&id=671ee675&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__